import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSlidesWide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconSlidesWide"><Path fillRule="evenodd" clipRule="evenodd" d="M2 6.75C2 5.23122 3.23122 4 4.75 4H15.25C16.7688 4 18 5.23122 18 6.75V8H19.25C20.7688 8 22 9.23122 22 10.75V17.25C22 18.7688 20.7688 20 19.25 20H8.75C7.23122 20 6 18.7688 6 17.25V16H4.75C3.23122 16 2 14.7688 2 13.25V6.75ZM6 10.75V14.5H4.75C4.05964 14.5 3.5 13.9404 3.5 13.25V6.75C3.5 6.05964 4.05964 5.5 4.75 5.5H15.25C15.9404 5.5 16.5 6.05964 16.5 6.75V8H8.75C7.23122 8 6 9.23122 6 10.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSlidesWide;
